
import '../../../../requestList/services/countryService';
import { RequestDetailEdit } from '../../../models/requestDetailEdit';
import { ICountryService } from '../../../../requestList/services/countryService';
import { Country } from '../../../../requestList/models/country';
import { RequestPickupDetail } from '../../../models/requestPickupDetail';

export class ShipmentLocationController {

    static $inject = ['countryService', '$q'];
    requestDetailEdit: RequestDetailEdit;
    shipmentLocationForm: ng.IFormController;
    shipmentLocationIsNotOtherForm: ng.IFormController;
    isFormRequestedFromAddNewRequest: boolean;
    isLoading: boolean;
    minDate: Date;
    usTerritories = ['US', 'AS', 'GU', 'MP', 'PR', 'VI'];


    constructor(private _countryService: ICountryService,
        private $q: ng.IQService) {
    }

    $onInit(): void {
        this.minDate = new Date();
        this.minDate.setDate(this.minDate.getDate() - 30);
        this.minDate.setHours(0, 0, 0, 0);        
        if (this.shipmentNotUndefined()) {
            var shipmentReadyDate = this.requestDetailEdit.requestDetail.requestShipment.shipmentReadyDate;
            if (shipmentReadyDate !== undefined && shipmentReadyDate.toString().length < 12) {
                this.requestDetailEdit.requestDetail.requestShipment.shipmentReadyDate = new Date(shipmentReadyDate.toString() + "T00:00");
            }
        }  

        this.populateValues();
        if (this.requestDetailEdit !== undefined)
            this.requestDetailEdit.requestDetail.requestShipment.location = 'Other';
    }

    get countries(): Country[] {
        return this._countries;
    }

    populateValues() {
        const deferred = this.$q.defer();
        this.isLoading = true;
        this.$q.all([this.populateCountries()])
            .then((values) => {
                this.handleGetCountries(values[0]);
                this.isLoading = false;
            })
            .catch((response) => {
                deferred.reject(this.getErrorReason(response.status));

            });
    }

    shipmentDateDisabled(): boolean {
        if (this.shipmentNotUndefined() &&
            this.requestDetailEdit.requestDetail.requestShipment.shipmentReadyDate !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment.shipmentReadyDate < this.minDate)
            return true;
        else {
            return false;
        }
    }

    private populateCountries(): ng.IPromise<Country[]> {
        const deferred = this.$q.defer<Country[]>();
        this._countryService.getCountryList()
            .then((countries) => {
                deferred.resolve(countries);
            })
            .catch((response) => {
                deferred.reject(response);
            });
        return deferred.promise;
    }

    private getErrorReason(status: any): string {
        var value = 'error';
        if (status !== undefined && status.toString() === "401")
            value = 'timeout';
        return value;
    }

    handleGetCountries(options: any) {
        this._countries = options;

    }

    _countries: Country[];

    handleCountryOpen(): void {
        this.requestDetailEdit.requestDetail.requestPickupDetail.countryCode = undefined;
    }


    isLocationIsOther(locationCode: string): boolean {
        return locationCode === "Other";
    }

    onLocationChange() {
        if (this.pickupDetailNotUndefined()) {
            this.requestDetailEdit.requestDetail.requestPickupDetail = new RequestPickupDetail(undefined);
        }

    }

    onCountryChange(countryCode: string) {
        this.requestDetailEdit.requestDetail.requestPickupDetail
            .countryName = this.countries.filter(o => o.countryCode === countryCode)[0].countryName;

    }

    pickupDetailNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestPickupDetail !== undefined;
    }

    shipmentNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment !== undefined;
    }

    get isValid(): boolean {
       
        if (this.shipmentNotUndefined() &&
            this.requestDetailEdit.requestDetail.requestShipment.location !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment.location === 'Other') {
           
            return (this.shipmentLocationForm ? this.shipmentLocationForm.$valid : false) &&
                (this.shipmentLocationIsNotOtherForm ? this.shipmentLocationIsNotOtherForm.$valid : false);

        }
        return (this.shipmentLocationIsNotOtherForm ? this.shipmentLocationIsNotOtherForm.$valid : false);
    }

    set isValid(val: boolean) { }

    get onClickCheck(): boolean {
       
        if (this.shipmentNotUndefined() && (this.usTerritories.indexOf(this.requestDetailEdit.requestDetail.requestConsignee.countryCode) < 0
            || this.usTerritories.indexOf(this.requestDetailEdit.requestDetail.requestPickupDetail.countryCode) < 0)
            && (!this.requestDetailEdit.requestDetail.requestShipment.chargeToConsignee)
            && (this.requestDetailEdit.requestDetail.requestShipment.isAsset)) {

            return false;

        }
           
        return true;
    }

    set onClickCheck(onClickCheck: boolean) {

    }

    get onClickMessage(): string {
        return 'Application of charges is required for asset shipments when "Ship To" or "Ship From" address is outside the US and its territories. Please adjust shipping address(es) or apply charges';
    }

    set onClickMessage(onClickMessage: string) {

    }

}




/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/shipmentLocation/controllers/shipmentLocationController.ts
 **/